/* Layout */
import Layout from '../../views/layout/Layout.vue'

const MarketplaceOrders = () => import(/* webpackChunkName: "marketplace-orders" */ '@/views/marketplace/orders')
const MarketplaceMerchants = () => import(/* webpackChunkName: "marketplace-merchants" */ '@/views/marketplace/merchants')
const MarketplaceSubscriptions = () => import(/* webpackChunkName: "marketplace-subscriptions" */ '@/views/marketplace/subscriptions')
const MarketplaceRefund = () => import(/* webpackChunkName: "marketplace-refund" */ '@/views/marketplace/refund')
const MarketplaceOrderSummary = () => import(/* webpackChunkName: "marketplace-ordersummary" */ '@/views/marketplace/orderSummary')
const MarketplaceCoupon = () => import(/* webpackChunkName: "marketplace-coupon" */ '@/views/marketplace/coupon')
const MarketplaceCreateCoupon = () => import(/* webpackChunkName: "marketplace-coupon" */ '@/views/marketplace/createCoupon')
const MarketplaceAddCoupon = () => import(/* webpackChunkName: "marketplace-coupon" */ '@/views/marketplace/addCoupon')


export default [
  {
    path: '/marketplace',
    component: Layout,
    redirect: 'noredirect',
    name: 'marketplace',
    alwaysShow: true,
    meta: {
      title: 'marketplace',
      icon: 'shopping-cart',
    },
    children: [
      {
        path: 'orders',
        component: MarketplaceOrders,
        name: 'orders',
        meta: {
          title: 'orders',
          icon: 'list',
          accessibleName: 'marketplace-orders',
        },
      },
      {
        path: 'merchants',
        component: MarketplaceMerchants,
        name: 'merchants',
        meta: {
          title: 'merchants',
          icon: 'list',
          accessibleName: 'marketplace-merchants',
        },
      },
      {
        path: 'subscriptions',
        component: MarketplaceSubscriptions,
        name: 'subscriptions',
        meta: {
          title: 'subscriptions',
          icon: 'list',
          accessibleName: 'marketplace-subscriptions',
        },
      },
      {
        path: 'refund',
        component: MarketplaceRefund,
        name: 'refund',
        meta: {
          title: 'Refund',
          icon: 'list',
          accessibleName: 'marketplace-refund',
        },
      },
      {
        path: 'ordersummary',
        component: MarketplaceOrderSummary,
        name: 'orderSummary',
        meta: {
          title: 'Order Summary',
          icon: 'list',
          accessibleName: 'marketplace-ordersummary',
        },
      },
      {
        path: 'coupon/list',
        component: MarketplaceCoupon,
        name: 'couponlist',
        meta: {
          title: 'Coupon List',
          icon: 'list',
          accessibleName: 'marketplace-coupon',
        },
      },
      {
        path: 'coupon/create',
        component: MarketplaceCreateCoupon,
        name: 'createcoupon',
        meta: {
          title: 'Create Coupon',
          icon: 'list',
          accessibleName: 'marketplace-create-coupon',
        },
      },
      {
        path: 'coupon/add/:id',
        component: MarketplaceAddCoupon,
        name: 'addcoupon',
        hidden: true,
        meta: {
          title: 'Add Coupon',
          icon: 'list',
          accessibleName: 'marketplace-add-coupon',
        },
      },
      // {
      //   path: 'featured-stores',
      //   component: () => import(/* webpackChunkName: "featured-stores" */ '@/views/marketplace/featuredStores'),
      //   name: 'featured-stores',
      //   meta: {
      //     title: 'featuredStores',
      //   }
      // },
      // {
      //   path: 'featured-banners',
      //   component: () => import(/* webpackChunkName: "featured-banners" */ '@/views/marketplace/featuredBanners'),
      //   name: 'featured-banners',
      //   meta: {
      //     title: 'featuredBanners',
      //   }
      // },
      // {
      //   path: 'featured-products',
      //   component: () => import(/* webpackChunkName: "featured-products" */ '@/views/marketplace/featuredProducts'),
      //   name: 'featured-products',
      //   meta: {
      //     title: 'featuredProducts',
      //   }
      // },
      // 
    ],
  },
]
